import * as React from "react";
import { connect } from "react-redux";
import { KeypadWrapperDesktop } from "../../../../ui/KeypadWrapperDesktop";
import { BetLevel } from "../../../../v2/components/BetLevel";
import { PaytableDesktop } from "../../../../v2/components/Paytable";
import { AutoplaySettingsDesktop } from "../../AutoplaySettings";
import { FooterDesktop } from "../../Footer";
import { KeypadDesktop } from "../../Keypad";
import { MenuDesktop } from "../../Menu";
import { TickerDisplayDesktop } from "../../TickerDisplay";
import { TopBarContainer } from "../../TopBar/TopBar";
import { DisplayMode } from "../../../../api/api";

export const View = ({ displayMode }) => (
  <>
    {(displayMode === DisplayMode.DEFAULT ||
      displayMode === DisplayMode.MINIMAL) && (
      <>
        <TickerDisplayDesktop />
        <MenuDesktop />
        <AutoplaySettingsDesktop />
        <BetLevel />
        <PaytableDesktop />
        <KeypadWrapperDesktop>
          <KeypadDesktop />
          <FooterDesktop />
        </KeypadWrapperDesktop>
      </>
    )}
    {displayMode === DisplayMode.TOPBAR && <TopBarContainer />}
  </>
);

const mapPropsToState = ({ displayMode }) => ({ displayMode });

export const DisplayModeSwitcher = connect(mapPropsToState)(View);
